import styled from 'styled-components';

export const FieldSearchWrap = styled.div`
  display: flex;
  height: 100%;
  overflow-y: none;

  .field-filters-wrap {
    margin-top: ${({ theme }) => theme.spacing02};
  }
  .field-filters {
    margin-top: ${({ theme }) => theme.spacing01};
    padding-bottom: ${({ theme }) => theme.spacing03};
    margin-bottom: ${({ theme }) => theme.spacing03};
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    border-bottom: 1px solid ${({ theme }) => theme.colorUI30};
  }

  .field-card-list {
    max-height: 100%;
    height: 100%;
  }

  .fields-information {
    margin-bottom: ${({ theme }) => theme.spacing04};
  }

  .fields-information-icon {
    color: ${({ theme }) => theme.colorUI80};
    font-size: ${({ theme }) => theme.fontSize04};
    color: ${({ theme }) => theme.colorPrimary70};
  }

  .fields-information-text {
    color: ${({ theme }) => theme.colorText50};
    text-transform: capitalize;
  }

  .field-information-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 25px;
  }

  .fields-information-number-of-fields {
    font-size: ${({ theme }) => theme.fontSize04};
    font-weight: ${({ theme }) => theme.fontWeightNormal};
    color: ${({ theme }) => theme.colorText70};
    margin-bottom: ${({ theme }) => theme.spacing02};
    line-height: ${({ theme }) => theme.fontSize05};
  }

  .chip {
    margin-right: ${(props) => props.theme.spacing01};
  }

  .chip-map-settings {
    position: absolute;
    top: ${({ theme }) => theme.spacing02};
    right: ${({ theme }) => theme.spacing02};
    z-index: 999999;
    margin-right: 0;
  }

  .map-settings-popup {
    position: absolute;
    z-index: 999;
    left: calc(100% - 600px - 16px);
    top: 64px;
    width: 600px;
  }

  .map-settings-icon {
    color: ${({ theme }) => theme.colorPrimary50};
    margin-left: ${({ theme }) => theme.spacing01};
  }
  .map-mapLayer-card-list-item {
    margin-bottom: ${({ theme }) => theme.spacing02};
  }

  .spinner-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    &.float-right {
      width: 50px;
      float: right;
    }
  }

  .reset {
    cursor: pointer;
    color: ${({ theme }) => theme.colorPrimary50};
  }
`;

export const Map = styled.div`
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  @media (max-width: ${({ theme }) => theme.desktopLarge}) {
    width: 100%;
  }

  .leaflet-popup-content-wrapper {
    border-radius: ${({ theme }) => theme.borderRadius};
  }
`;
export const MapFilterPanel = styled.div`
  position: absolute;
  z-index: 99999999;
  top: 25px;
  right: 25px;
`;

export const SearchNewFieldsPanel = styled.div`
  background: white;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 25px;
  z-index: 999;
  background: white;
  padding: ${({ theme }) => theme.spacing01} ${({ theme }) => theme.spacing01};
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: ${({ theme }) => theme.borderRadius};

  .zoom-in-alert {
    padding: 10px;
    line-height: 25px;
  }
`;
